import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { useLanguage } from '../../context/LanguageContext';
import { homeTranslations } from '../../locales/homeTranslations';
import './Footer.css';

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

const Footer = () => {
  const { currentLanguage } = useLanguage();
  const t = homeTranslations[currentLanguage] || homeTranslations.en;
  const tFooter = t.footer || homeTranslations.en.footer;

  return (
    <div className="pg-footer">
      <footer className="footer">
        <svg className="footer-wave-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 100" preserveAspectRatio="none">
          <path className="footer-wave-path" d="M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z"></path>
        </svg>
        <div className="footer-content">
          <div className="footer-content-column">
            <div className="footer-logo">
              <Link to="/" className="footer-logo-link">
                <img
                  src="/arc-logo2.png"
                  alt="ARC Publication Logo"
                  style={{ maxWidth: '180px', height: 'auto' }}
                />
              </Link>
              <Typography variant="body2" sx={{ mt: 2, color: '#000', maxWidth: '300px' }}>
                {tFooter.tagline}
              </Typography>
            </div>

          </div>
          <div className="footer-content-column">
            <div className="footer-menu">
              <h2 className="footer-menu-name">{tFooter.quickLinks}</h2>
              <ul id="menu-quick-links" className="footer-menu-list">

                <li className="menu-item">
                  <Link to="/#about" onClick={() => {
                    setTimeout(() => {
                      const element = document.getElementById('about');
                      if (element) {
                        const headerOffset = 100;
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                        window.scrollTo({
                          top: offsetPosition,
                          behavior: 'smooth'
                        });
                      }
                    }, 100);
                  }}>{tFooter.aboutUs}</Link>
                </li>
                <li className="menu-item">
                  <Link to="/guidelines" onClick={scrollToTop}>{tFooter.guidelines}</Link>
                </li>
                <li className="menu-item">
                  <Link to="/policies" onClick={scrollToTop}>{tFooter.policies}</Link>
                </li>
                <li className="menu-item">
                  <Link to="/contact" onClick={scrollToTop}>{tFooter.contactUs}</Link>
                </li>
                <li className="menu-item">
                  <Link to="/contact" onClick={scrollToTop}>{tFooter.submitPaper}</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-content-column">
            <div className="footer-contact-info">
              <h2 className="footer-menu-name">{tFooter.contactUs}</h2>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                <LocationOnIcon sx={{ color: '#2c3e50', mr: 1, mt: 0.5 }} />
                <Typography variant="body2" sx={{ color: '#000', lineHeight: '1.6' }}>
                  {tFooter.address}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <EmailIcon sx={{ color: '#2c3e50', mr: 1 }} />
                <a href="mailto:contact@arcpublishing.org" style={{ textDecoration: 'none', color: '#000' }}>
                  <Typography variant="body2" sx={{ color: '#000', '&:hover': { color: '#d7a449' } }}>
                    contact@arcpublishing.org
                  </Typography>
                </a>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <PhoneIcon sx={{ color: '#2c3e50', mr: 1 }} />
                <a href="tel:+971508370576" style={{ textDecoration: 'none', color: '#000' }}>
                  <Typography variant="body2" sx={{ color: '#000', '&:hover': { color: '#d7a449' } }}>
                    +971 50 837 0576
                  </Typography>
                </a>
              </Box>
            </div>
          </div>

          <div className="footer-content-column">
            <div className="footer-call-to-action">
              <h2 className="footer-call-to-action-title">{tFooter.letsChat}</h2>
              <p className="footer-call-to-action-description">{tFooter.haveQuestion}</p>
              <Link to="/contact" className="footer-call-to-action-button" onClick={scrollToTop}>{tFooter.getInTouch}</Link>
            </div>
          </div>

        </div>
        <div className="footer-copyright">
          <div className="footer-copyright-wrapper">
            <p className="footer-copyright-text">
              {tFooter.copyright}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
